<div class="card-headd text-center  ">
    <div class="row details-header">
        <div class="col-1 d-flex align-items-center">
        <button type="button" class="btn-dt-retourr mt-1" (click)="returnToList()">
            <div class="icon-position">
                <i class="fa-solid fa-arrow-left fa-icon-style fa-lg"></i>

            </div>
        </button>
    </div>
    <div class="col-2 customMargin" *ngIf="informationsContrat?.solde?.date "> 
         <div class="montant p-2" >
        <img src="assets/icons/montantIcon.svg" >
        <div class="d-flex flex-column" *ngIf="!loaderMontant">
            <div class="d-flex montantNum">
                <p class="m-0">{{informationsContrat?.solde?.montant |currency:currency:'symbol':formatCurrency:'fr-FR'}}</p>
                <!-- <p class="fractional m-0 mt-1 ">{{  fractionalPart}}</p> -->
                <!-- <p class="fractional m-0"> {{currentCurrency}}</p> -->
            </div>
          
            <p class="montantDate m-0">
                {{extractDate(informationsContrat?.solde?.date)}}
            </p>

        </div>
        <ng-container *ngIf="loaderMontant">
            <div class="">
                <div class="text-center m-auto ">
                    <mat-spinner [diameter]="15"></mat-spinner>

                </div>
            </div>
        </ng-container>
                </div>
               
            </div>
      <p></p>
        <div class="col-9 d-flex justify-content-end align-items-center pr-0">
            
            <div class=" row d-flex  align-items-center">
                <button type="button" class="btn-load mt-0 mr-2" id="clear" (click)="Actualise()">
                    <i class="fa-solid fa-rotate-right"></i>
                </button>
                <button type="button" [ngClass]="{'cover': !allowed_to_update_affaire}" class="Avenant-btn"
                (click)="openModalOrPopup()" [disabled]="!acces_avenant || !informationsContrat?.autorisation_avenant" data-toggle="modal" data-target="#myModal"
                [ngStyle]="{'opacity':!acces_avenant || !informationsContrat?.autorisation_avenant ? 0.4 : 1}"
                [matTooltip]="'languages.affaire.AllowcreateAvenant' | translate" 
        matTooltipPosition="above"
        [matTooltipDisabled]="!(acces_avenant && !informationsContrat?.autorisation_avenant)">
        
<i class="fa-solid fa-square-plus fa-xl"></i>&nbsp;
                <span>{{'languages.affaire.createAvenant' | translate}}</span>
            </button>

            <app-shared-button-enrg [type]="'A'" data-toggle="modal" [allowed_to_update]="allowed_to_update_affaire"
                data-target="#Actions" (click)="getStatusAutorise()" class="ml-2"
                [label]="Enregistrer"></app-shared-button-enrg>
            
                  
           
            </div>


           
        </div>
    </div>

</div>


<div class="row custem-margin">
    <div class="col-4 w-100">
        <div class="card-head  w-100 float-left">
            <div class="row">
                <!-- <div class="col-1  p-0" *ngIf="societe?.type_opportunite=== 'entrepise'">
                    <svg class="mt-3" xmlns="http://www.w3.org/2000/svg" width="47.009" height="46.999"
                        viewBox="0 0 47.009 46.999">
                        <g id="Groupe_3556" data-name="Groupe 3556" transform="translate(-121.5 -24.004)">
                            <path id="Tracé_6392" data-name="Tracé 6392"
                                d="M121.5,97.984c.088-.662.192-1.323.262-1.987q.655-6.178,1.294-12.357a.953.953,0,0,1,.765-.855c1.958-.645,3.908-1.311,5.869-1.944.336-.108.455-.249.439-.6-.03-.7,0-1.407-.017-2.11a.7.7,0,0,0-.181-.472,12.588,12.588,0,0,1-4.411-8.091c-.8-.282-.881-.41-.9-1.267a12.414,12.414,0,0,1,.754-5.087,10.6,10.6,0,0,1,8.646-6.875,10.826,10.826,0,0,1,11.994,7.432,11.426,11.426,0,0,1,.537,4.16.775.775,0,0,1-.718.793c-.226,1.05-.382,2.079-.674,3.069a11.877,11.877,0,0,1-3.779,5.736.805.805,0,0,0-.314.7c.019.657.028,1.316,0,1.972a.541.541,0,0,0,.454.644c1.847.591,3.672,1.247,5.526,1.816.748.229,1.169.6,1.148,1.406a2.414,2.414,0,0,0,.042.327h18.338c1.348,0,1.921.576,1.921,1.929,0,3.64-.02,7.28.013,10.919a1.9,1.9,0,0,1-1.206,2.028H121.5Zm15.724-33.773a31.922,31.922,0,0,0-9.972,4.233.549.549,0,0,0-.2.4,4.483,4.483,0,0,0,.08.865,11.079,11.079,0,0,0,3.546,6.507,7.3,7.3,0,0,0,8.713.834,10.233,10.233,0,0,0,4.142-5.271,10.023,10.023,0,0,0,.626-3.082C140.692,68.981,138.211,67.763,137.224,64.211Zm12.393,33.459h17.278V88.184c-.464.81-.89,1.517-1.279,2.243a1.812,1.812,0,0,1-1.753,1.019c-1.376-.011-2.753,0-4.129,0H159.1c0,.278.016.5,0,.727-.043.516-.3.816-.8.825q-1.926.037-3.853,0a.777.777,0,0,1-.814-.858c-.008-.222,0-.445,0-.662h-4.656Zm-4.639-30.435a9.377,9.377,0,1,0-18.753-.091c.03,0,.066.015.088,0,.147-.08.293-.162.435-.251a33.7,33.7,0,0,1,10.729-4.352c.877-.192,1.208.059,1.279.973a3.676,3.676,0,0,0,2.739,3.41A24.929,24.929,0,0,0,144.978,67.236Zm-3.866,15.12V97.676h6.917c-.01-.166-.013-.3-.027-.438q-.671-6.334-1.335-12.669a.5.5,0,0,0-.4-.509c-1.351-.435-2.7-.889-4.042-1.335Zm-11.009.011c-.172.047-.317.081-.458.128q-1.977.659-3.952,1.323c-1.154.386-1.132.388-1.255,1.6-.314,3.1-.649,6.2-.975,9.3-.1.981-.2,1.962-.3,2.947H130.1Zm36.238,3.619H148.385c.126,1.185.263,2.338.363,3.493.028.324.142.4.447.4,1.33-.013,2.661,0,3.992-.007.133,0,.267-.018.433-.03,0-.229,0-.426,0-.623.014-.6.271-.9.853-.907q1.881-.027,3.762,0c.56.008.822.292.862.86.015.22,0,.443,0,.636a.9.9,0,0,0,.165.055c.994,0,1.988.013,2.982.008a4.14,4.14,0,0,0,1.84-.1c.46-.261.657-.991.962-1.519C165.472,87.516,165.89,86.776,166.341,85.986Zm-34.655-7.209c0,1.157-.008,2.242.012,3.327a.516.516,0,0,0,.255.358q1.69.87,3.4,1.7a.6.6,0,0,0,.457.016q1.731-.838,3.442-1.718a.476.476,0,0,0,.241-.325c.018-1.1.011-2.194.011-3.35A9.021,9.021,0,0,1,131.686,78.777Zm2.772,7.6c-.844.28-1.59.545-2.348.77a.522.522,0,0,0-.434.608c.015,3.149.009,6.3.009,9.446v.477h2.631c-.518-1.038-.989-2.045-1.52-3.019A2.048,2.048,0,0,1,132.639,93C133.259,90.831,133.837,88.651,134.458,86.38Zm5.048,11.312V88.263c0-.966,0-.968-.9-1.268-.6-.2-1.2-.392-1.85-.605.053.218.083.35.118.481.582,2.133,1.159,4.267,1.752,6.4a1.465,1.465,0,0,1-.108,1.142c-.5.96-.973,1.934-1.455,2.9-.056.114-.1.236-.155.379Zm-3.862-9.37-.088-.016q-.715,2.627-1.426,5.256a.4.4,0,0,0,.022.259c.467.95.941,1.9,1.447,2.911.411-.823.755-1.59,1.172-2.316a1.721,1.721,0,0,0,.153-1.465C136.467,91.415,136.066,89.865,135.643,88.321Zm19.563,3.087h2.3v-1.5h-2.3Zm-23.5-5.769,1.846-.612L131.7,84.1Zm7.774,0V84.108l-1.833.911Z"
                                transform="translate(0 -28.265)" />
                            <path id="Tracé_6393" data-name="Tracé 6393"
                                d="M303.658,30.029l-1.159-.981a14.069,14.069,0,1,1,.8,19.015l1.128-1.029a12.424,12.424,0,0,0,10.517,3.472,12.042,12.042,0,0,0,7.972-4.451,12.51,12.51,0,0,0-.864-16.85,12.228,12.228,0,0,0-9.351-3.6A12.41,12.41,0,0,0,303.658,30.029Z"
                                transform="translate(-158.848)" />
                            <path id="Tracé_6394" data-name="Tracé 6394"
                                d="M337.057,52.653l-.794-1.254a10.929,10.929,0,1,1-.909,17.849l.935-1.2a9.4,9.4,0,0,0,7.728,1.767,9.03,9.03,0,0,0,5.248-3.147,9.408,9.408,0,0,0-12.209-14.015Z"
                                transform="translate(-187.682 -22.52)" />
                            <path id="Tracé_6395" data-name="Tracé 6395"
                                d="M355.937,111.069l.58-1.45c1,.4,1.987.762,2.942,1.188a1.178,1.178,0,0,0,1.215-.09c1.493-.888,3.012-1.734,4.558-2.618l.774,1.344c-.146.09-.272.171-.4.245-1.576.9-3.16,1.79-4.724,2.713a1.442,1.442,0,0,1-1.424.092C358.31,112,357.143,111.554,355.937,111.069Z"
                                transform="translate(-205.746 -73.803)" />
                            <path id="Tracé_6396" data-name="Tracé 6396" d="M385.729,69.127v1.5h-1.5v-1.5Z"
                                transform="translate(-230.571 -39.6)" />
                            <path id="Tracé_6397" data-name="Tracé 6397" d="M449.542,133.086v1.5H448.02v-1.5Z"
                                transform="translate(-286.559 -95.732)" />
                            <path id="Tracé_6398" data-name="Tracé 6398" d="M384.167,196.994h1.5v1.511h-1.5Z"
                                transform="translate(-230.521 -151.819)" />
                        </g>
                    </svg>
                </div>
                <div class="col-1  p-0" *ngIf="societe?.type_opportunite !== 'entrepise'">
                    <svg class="mt-3" width="63" height="61" viewBox="0 0 63 61" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect width="40" height="48.4127" fill="white" />
                        <rect width="63" height="61" fill="white" />
                        <path
                            d="M4.00484 58.9721C4.00484 58.207 4.00484 57.4418 4.00484 56.6767C3.99863 54.6683 3.99344 52.5966 4.02245 50.5654C4.10714 46.6738 5.56058 42.9366 8.12739 40.0104C10.6504 37.053 14.1453 35.0921 17.9843 34.4802C19.3649 34.3064 20.7558 34.2272 22.1472 34.243C22.7853 34.2357 23.444 34.2285 24.0976 34.2026C24.1847 34.2026 24.2727 34.2026 24.3628 34.2026H24.6073H24.6301H24.9139H25.5592V33.5572C25.5592 33.3356 25.5592 33.117 25.5592 32.9026V32.8726C25.5592 32.219 25.5664 31.6006 25.5385 30.9708C25.5112 30.7722 25.4363 30.5831 25.3202 30.4197C25.204 30.2563 25.05 30.1234 24.8714 30.0324C23.4932 29.1466 22.3065 27.9936 21.3814 26.6415C20.4562 25.2894 19.8115 23.7656 19.4852 22.1601C19.2971 21.2163 19.201 20.2564 19.1982 19.294C19.1703 16.8018 19.1754 14.2713 19.1806 11.8237C19.1806 11.0903 19.1806 10.3573 19.1806 9.62466C19.129 7.81288 19.7428 6.04494 20.906 4.65495C22.0693 3.26497 23.7014 2.34923 25.4939 2.08079C25.578 2.06498 25.6596 2.03779 25.7363 2H47.4719C47.4719 2.40708 47.4719 2.81415 47.4719 3.21294C47.4719 4.58644 47.4719 6.00965 47.358 7.38004C47.2596 8.2795 46.9747 9.14855 46.5215 9.93169C46.0684 10.7148 45.4568 11.3949 44.726 11.9283C44.5079 12.0911 44.3333 12.305 44.2175 12.5512C44.1017 12.7974 44.0483 13.0684 44.062 13.3401C44.062 13.7427 44.0658 14.1453 44.0734 14.5479C44.091 16.2808 44.1086 18.0624 44.0548 19.8047C44.0375 21.8749 43.4943 23.9067 42.4762 25.7094C41.4581 27.5121 39.9985 29.0263 38.2345 30.11C37.9667 30.2606 37.7485 30.4858 37.6063 30.7581C37.4642 31.0305 37.4042 31.3383 37.4338 31.6441C37.4576 32.0201 37.4556 32.4137 37.4525 32.7949V32.8208C37.4525 33.0052 37.4525 33.1885 37.4525 33.3729C37.4551 33.4818 37.479 33.5891 37.5229 33.6888C37.5312 33.7095 37.5405 33.7333 37.5519 33.7665L37.7031 34.1984H38.161H38.3681H38.5867C38.6654 34.1984 38.7452 34.1984 38.8249 34.1984C39.4889 34.2253 40.1601 34.2326 40.8085 34.2409C42.2279 34.2263 43.6467 34.3066 45.0554 34.4812C48.4813 35.0588 51.6417 36.6905 54.0964 39.1491C56.5511 41.6077 58.1778 44.7707 58.7499 48.1975C58.8926 49.1034 58.9704 50.0182 58.983 50.9352C59.0047 53.0068 59.0006 55.1137 58.9975 57.1563C58.9975 57.7612 58.9975 58.3661 58.9975 58.9711L4.00484 58.9721ZM6.56745 56.858H13.2516V50.208H15.3761V56.8435H47.6594V50.2246H49.7839V56.8466H56.8616V56.2013C56.8616 55.6557 56.8616 55.1137 56.8616 54.575V54.4715C56.8616 53.2513 56.8709 51.9855 56.8533 50.7518C56.7808 47.6358 55.7261 44.6223 53.8396 42.1412C51.9531 39.66 49.3313 37.838 46.3481 36.9351C44.6823 36.4844 42.9591 36.282 41.2342 36.3343C40.764 36.3343 40.274 36.3415 39.8431 36.3477H39.8017C39.3635 36.354 38.913 36.3602 38.4707 36.3602H38.2024C38.1052 36.3615 38.0093 36.3824 37.9203 36.4215C37.8313 36.4607 37.7511 36.5173 37.6845 36.5881C37.6741 36.5984 37.6669 36.6057 37.6565 36.614L37.4235 36.8076V38.9756H36.6756C36.126 38.938 35.5746 39.0185 35.0587 39.2116C34.5427 39.4047 34.0741 39.706 33.6842 40.0952C33.2942 40.4845 32.9921 40.9526 32.7981 41.4682C32.6041 41.9838 32.5227 42.535 32.5593 43.0847C32.5593 43.729 32.5593 44.3733 32.5593 45.0321V45.6183H30.4348V45.1771C30.4348 44.4168 30.4348 43.6813 30.4348 42.9459C30.4613 42.4179 30.377 41.8902 30.1871 41.3968C29.9972 40.9034 29.706 40.4553 29.3323 40.0813C28.9587 39.7074 28.5108 39.4158 28.0175 39.2256C27.5243 39.0353 26.9967 38.9505 26.4686 38.9767H25.5364V36.2545L24.8714 36.2742C24.2447 36.2928 23.6118 36.3001 22.9997 36.3073C21.5858 36.3229 20.2631 36.3374 18.9092 36.4814C15.8458 36.8871 12.9877 38.2466 10.7401 40.3673C8.49242 42.488 6.96917 45.2623 6.38619 48.297C6.12434 50.1429 6.04005 52.0097 6.13448 53.8717C6.14898 54.6123 6.16348 55.3768 6.15313 56.1215C6.15267 56.2207 6.17321 56.3189 6.21338 56.4095C6.25354 56.5002 6.31244 56.5814 6.38619 56.6477L6.56745 56.858ZM27.6857 33.1657C27.6857 34.2015 27.6857 35.1659 27.6981 36.1375C27.7091 36.348 27.7805 36.5509 27.9037 36.722C28.027 36.893 28.1969 37.0249 28.3932 37.1018C29.4016 37.4434 30.3114 38.0258 31.0439 38.7985L31.5069 39.2677L31.9657 38.7943C32.6841 38.0224 33.5864 37.4451 34.5884 37.1163C34.7864 37.0409 34.9586 36.9102 35.0846 36.7398C35.2105 36.5694 35.2849 36.3665 35.299 36.1551C35.3145 35.1731 35.3125 34.214 35.3114 33.1978V31.526L34.5232 31.7052C33.5861 31.9182 32.6283 32.0263 31.6674 32.0273C30.5936 32.0242 29.5238 31.897 28.4792 31.6482L27.6878 31.4649L27.6857 33.1657ZM30.9734 13.5691C28.9487 13.5691 26.9247 13.5691 24.9014 13.5691C24.4421 13.5527 23.9841 13.6283 23.5542 13.7912C23.1244 13.9541 22.7314 14.2011 22.3982 14.5178C22.065 14.8344 21.7984 15.2144 21.6139 15.6354C21.4294 16.0564 21.3307 16.51 21.3237 16.9696C21.2711 18.1898 21.2942 19.412 21.3931 20.6292C21.6235 23.0627 22.7167 25.3335 24.4753 27.0312C26.2338 28.729 28.5416 29.7417 30.9817 29.8863C31.1661 29.8956 31.3536 29.9008 31.5379 29.9008C33.9206 29.9544 36.2452 29.1618 38.0987 27.6636C39.9523 26.1654 41.2148 24.0588 41.662 21.7178C41.9097 19.9981 42.0212 18.2615 41.9956 16.5242C42.0038 15.7702 42.0121 14.9923 42.0453 14.2361L42.0743 13.5628L30.9734 13.5691ZM34.7345 4.1255C31.3991 4.1255 28.822 4.13171 26.3806 4.14621C25.1488 4.16301 23.965 4.62632 23.0491 5.45006C22.1331 6.27381 21.5473 7.40201 21.4004 8.6251C21.3367 9.26457 21.3232 9.90806 21.36 10.5496C21.3683 10.819 21.3776 11.0903 21.3776 11.3472V12.1666L22.1772 11.9708C22.4031 11.9149 22.6278 11.8537 22.8516 11.7926C23.3092 11.6553 23.7762 11.5515 24.2489 11.4819C24.5739 11.4456 24.9008 11.4293 25.2277 11.4332C25.4245 11.4332 25.6224 11.4332 25.8202 11.4404C26.0181 11.4477 26.2345 11.4477 26.4417 11.4477C27.7137 11.4477 28.9784 11.4477 30.2432 11.4404H30.3209C31.6785 11.437 33.0361 11.4346 34.3937 11.4332C36.4891 11.4332 38.2117 11.4415 39.8162 11.4612H39.8866C40.6889 11.4751 41.4845 11.3138 42.218 10.9885C42.9515 10.6633 43.6052 10.1819 44.1335 9.57805C44.68 8.90423 45.0673 8.11573 45.2666 7.27134C45.4658 6.42695 45.4719 5.54847 45.2843 4.70142L45.2097 4.25601L44.7653 4.17315H44.7488C44.6639 4.15091 44.5765 4.13908 44.4888 4.13793H44.4546H39.8462H39.5987L34.7345 4.1255Z"
                            fill="black" />
                    </svg>
                </div> -->
                <div class="col-12 p-0">
                    <div class="row ">
                        <div class="col-12 text-nowrap ">
                            {{'languages.affaire.nContrat' | translate}}: 
                            <label
                                class="label-card-info " [title]="numContrat"> {{expandNumContrat(numContrat)}}  
                            </label>
                        </div>
                        <div class="col-12 text-nowrap ">
                            <!-- Version :
                            <label class="label-card-info">{{informationsContrat?.contrat?.version}} </label> -->
                            {{'languages.affaire.label_dateeffet' | translate}}: 
                            <label class="label-card-info">
                               {{informationsContrat?.contrat?.date_deff ? transformDateDeff:
                                "---"}} 
                             
                            </label>
                        </div>
                        <div class="col-12 text-nowrap ">
                            {{'languages.opportunite.opportuniteNum' | translate}}:
                            <label class="label-card-info">
                                <a class="a-style row cursor-pointer" target="_blank"
                                    (click)="NaviagateToOppoDetials(informationsContrat?.contrat.id_opp_md5)">
                                    {{informationsContrat?.contrat.id_opp}}
                                </a>
                            </label>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>


    <div class="col-4 w-100">
        <div class="card-head w-100">
            <div class="row justify-content-center">
                <!--       <div class="col-12" *ngIf="societe?.type_opportunite !== 'entrepise'">
                    <label class="label-card-info"></label>
                </div> -->
                <div class="text-nowrap col-12" *ngIf="informationsContrat?.contrat?.nom_organisme">
                    {{'languages.campagne.Organisme' | translate}} :
                    <label class="label-card-info">
                        {{informationsContrat?.contrat?.nom_organisme}}
                    </label>
                </div>
                <div class="text-nowrap col-12">
                    {{'languages.opportunite.Interlocuteur' | translate}} :
                    <label class="label-card-info">
                        {{informationsContrat?.contrat?.nom_commerciale}}
                    </label>
                </div>

                <div class="text-nowrap col-12" *ngIf="societe?.type_opportunite !== 'entrepise'">
                    {{'languages.opportunite.Client' | translate}}:
                    <label class="label-card-info">
                        {{informationsContrat?.contrat?.nom_pros}}
                    </label>
                </div>
                <!-- <div class="text-nowrap col-12" *ngIf="societe?.type_opportunite === 'entrepise'">
                    Interlocuteur :
                    <label class="label-card-info">
                        {{informationsContrat?.contrat?.nom_pros}}
                    </label>
                </div> -->

                <div class="text-nowrap col-12" *ngIf="societe?.type_opportunite=== 'entrepise'">
                    {{'languages.opportunite.Societe' | translate}}:
                    <label class="label-card-info">
                        {{societe?.RS}}
                    </label>
                </div>

            </div>
        </div>
    </div>
    <div class="col-4 w-100 ">
        <div class="card-head mr-2 w-100">
            <div class="row">
                <div class="text-nowrap col-12">

                    <div class="col-2 mrgin  ">
                        {{'languages.affaire.label_gamme' | translate}}:
                        <label class="label-card-info">
                            {{informationsContrat.contrat.gamme?.nom}}

                        </label>

                    </div>
                    <!-- <div class="col-6"></div>
                        <div class="col">
                          <svg data-toggle="modal" *ngIf="allowed_to_update_affaire" data-target="#Actions"
                                (click)="showModalUpdateStatut()" class=" float-right cursor-pointer" width="25"
                                height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12.5" cy="12.5" r="12.5" fill="#D9D9D9" />
                                <path
                                    d="M14.0857 6.91356L18.0862 10.9143L9.39929 19.6016L5.83251 19.9953C5.35502 20.0482 4.95159 19.6444 5.00471 19.1669L5.40158 15.5975L14.0857 6.91356ZM20.5606 6.31793L18.6822 4.43946C18.0962 3.85351 17.146 3.85351 16.56 4.43946L14.7929 6.20668L18.7934 10.2074L20.5606 8.44015C21.1465 7.85389 21.1465 6.90388 20.5606 6.31793Z"
                                    fill="#474747" />
                            </svg> 
                        </div> -->



                </div>
                <div class="text-nowrap col-12">
                    <label> {{'languages.opportunite.statusActuel' | translate}}:</label>
                    <label 
                     data-toggle="modal" data-target="#Actions"
                        class="VAD ml-2 mr-2 text-center border-0 cursor-pointer "
                        (click)="showModalUpdateStatut()"
                        [class.disabled]="allowed_to_update_affaire== false"
                        [style.background]="informationsContrat?.contrat?.etat_dossier_background"
                        [style.color]="informationsContrat?.contrat?.etat_dossier_color"
                         >
                        {{expandFileName(informationsContrat?.contrat?.status)}}
                            <i class="fa-solid fa-pen cursor-pointer float-right mt-1 " *ngIf="allowed_to_update_affaire"
                            data-toggle="modal" data-target="#Actions" (click)="showModalUpdateStatut()"></i>
                    </label>
                </div>
                <div class="text-nowrap col-12">
                    <label> {{'languages.affaire.Motif' | translate}}:</label>
                    <label class="label-card-info" *ngIf="!informationsContrat?.contrat?.motif?.libelle">  {{'languages.affaire.noMotif' | translate}}</label>
                    <label 
                    class="VAD ml-2 text-center border-0 cursor-pointer" 
                    data-toggle="modal" data-target="#MotifChange" 
                     (click)="getMotifByStatutActuel()"
                     [class.disabled]="allowed_to_update_affaire== false"
                        *ngIf="informationsContrat?.contrat?.motif?.libelle"
                        [style.background]="informationsContrat?.contrat?.motif?.background"
                        [style.color]="informationsContrat?.contrat?.motif?.color"
                         >
                        {{expandFileName(informationsContrat?.contrat?.motif?.libelle)}}
                        <i class="fa-solid fa-pen cursor-pointer float-right mt-1" data-toggle="modal"
                            data-target="#MotifChange" (click)="getMotifByStatutActuel()"
                            *ngIf="allowed_to_update_affaire "></i>
                    </label>

                </div>
            </div>
        </div>

    </div>
</div>
<div class="row ml-2" *ngIf="informationsContrat.contrat.id ">
    <div class="col" style="max-width: 248px;">
        <div class="sidebar-affaire " id="scrollbar-affaire">
            <div class="card card-affaire bg-white text-center border-0">
                <div class="mt-1">

                    <div class="col py-1">
                        <button (click)="scroll('cord')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-user-tie fa-lg"></i>
                            </label>
                            <span> {{'languages.prospect.adherentSouscipteur' | translate}}</span>
                        </button>
                    </div>

                    <div class="col py-1">
                        <button (click)="scroll('infcont')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-file-contract fa-lg"></i>
                            </label>
                            <span>{{'languages.affaire.infoContrat' | translate}}</span>
                        </button>
                    </div>

                    <div class="col py-1">
                        <button (click)="scroll('garantie')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-umbrella fa-lg "></i>
                            </label>
                            <span>{{'languages.affaire.garanties' | translate}}</span>
                        </button>
                    </div>
                    <div *ngIf="bien" class="col py-1">
                        <button (click)="scroll('objetAssurer')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-object-ungroup fa-lg"></i>
                            </label>
                            <span> {{'languages.produit.objetAssure' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1">
                        <button (click)="scroll('information-bancaire')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-landmark fa-lg"></i>
                            </label>
                            <span>{{'languages.affaire.infoBancaire' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1" *ngIf="lecture_transaction_financiere_client">
                        <button (click)="scroll('echeancier')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-file-invoice-dollar fa-lg"></i>
                            </label>
                            <span>{{'languages.affaire.echeanciers' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1">
                        <button (click)="scroll('paimentfrais')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-credit-card fa-lg"></i>
                            </label>
                            <span>{{'languages.affaire.fraisAndPaiment' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1 "  *ngIf="lecture_transaction_financiere_client">
                        <button (click)="scroll('transactionFinanciere')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-right-left fa-lg"></i>
                            </label>
                            <span>{{'languages.affaire.transactionsFinanciere' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1">
                        <button (click)="scroll('ListDocuments')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-file-import fa-lg"></i>
                            </label>
                            <span>{{'languages.navbar.OppDetailsDocument' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1">
                        <button (click)="scroll('LiaisonsContrats')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-retweet fa-lg"></i>
                            </label>
                            <span>{{'languages.affaire.relationAffaire' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1">
                        <button (click)="scroll('Tickets')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-ticket-simple fa-lg"></i>
                            </label>
                            <span>{{'languages.navbar.OppDetailsTickets' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1">
                        <button (click)="scroll('tache')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-list-check fa-lg"></i>
                            </label>
                            <span> {{'languages.affaire.todoList' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1">
                        <button (click)="scroll('InfAvancee')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-circle-question fa-lg"></i>
                            </label>
                            <span>{{'languages.affaire.infoAvancee' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1">
                        <button (click)="scroll('comment')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-comment-dots fa-lg"></i>
                            </label>
                            <span>{{'languages.opportunite.details.commentaire_label' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1">
                        <button (click)="scroll('Communication')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-comments fa-lg"></i>
                            </label>
                            <span>{{'languages.opportunite.label_communication' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1" *ngIf="histAccess">
                        <button (click)="scroll('Historique')"
                            class=" focus-style d-block border-0 full-width text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-clock-rotate-left fa-lg"></i>
                            </label>
                            <span> {{'languages.opportunite.details.label_history' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1" *ngIf="histCommAccess">
                        <button (click)="scroll('HistoriqueCommunication')"
                            class=" focus-style full-width d-block border-0 text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-clock-rotate-left fa-lg"></i>
                            </label>
                            <span>{{'languages.opportunite.details.HistoriqueCommunications' | translate}}</span>
                        </button>
                    </div>
                    <div class="col py-1"  *ngIf="access_qualite">
                        <button (click)="scroll('qualite')"
                            class=" focus-style full-width d-block border-0 text-left pl-3">
                            <label class="align-details-icon">
                                <i class="fa-solid fa-medal fa-lg"></i>
                            </label>
                            <span>{{'languages.settings.infoBlocQualite' | translate}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="text-left">
                <shared-tags [isReadOnly]="allowed_to_update_affaire" [affaire_id]="affaire_id"></shared-tags>
            </div>
        </div>
    </div>


    <div class="col p-1 overflow-auto" *ngIf="informationsContrat.contrat.id ">
        <div class="row">
            <div class="col-12 p-0">
                <div class="ml-4">
                    <!--      <div class="p-2 mb-2" id="infoAffaire">
                        <app-info-affaire [informationsContrat]="informationsContrat"
                            [societe]="societe"></app-info-affaire>
                    </div> -->
                    <div class="p-2 " id="stat">
                        <app-status [listOfProcesses]="listOfProcess"></app-status>
                    </div>
                    <div class="p-2 " id="cord" *ngIf="informationsContrat.contrat.id_prospect.toString()">
                        <app-cordonnees-client [person]="person" *ngIf="prospect?.mainProspect?.id" [prospectDetails]="prospect"
                            [allowed_to_update_affaire]="informationsContrat.contrat.allowed_to_update"
                            (onUpdateSociete)="onUpdateSociete($event)" (ErroronUpdateSociete)="getError($event)"
                            [affaireId]="affaire_id">
                        </app-cordonnees-client>
                    </div>

                    <div class="p-2 " id="infcont" *ngIf="informationsContrat.contrat.id ">
                        <app-informations-contract [informationsContrat]="informationsContrat"
                            (onUpdateinformationsContrat)="onUpdateContrat($event)"
                            [allowed_to_update_affaire]="allowed_to_update_affaire">
                        </app-informations-contract>
                    </div>
                    <div class="p-2 " id="garantie" [ngClass]="{'cover': !allowed_to_update_affaire}">
                        
                            <div class="scrollbar">
                                <app-garantie [affaire_id]="affaire_id" [allowed_to_update]="allowed_to_update_affaire"
                                    (garantiexport)="onUpdateGaranties($event)"></app-garantie>
                            </div>
                       
                    </div>
                    <div class="p-2 " *ngIf="bien" id="objetAssurer" [ngClass]="{'cover': !allowed_to_update_affaire}">
                        <div class="card bg-white border-0 p-3">



                            <div class="scrollbar ">
                                <app-objet-assurer-aff [affaire_id]="affaire_id" [opportunity_id]="id_opportunite"
                                    [bien]="bien"
                                    (updateObjetAsuure)="updateobjetAssure($event)"></app-objet-assurer-aff>
                            </div>


                        </div>
                    </div>
                    <div class="p-2  ml-1" id="information-bancaire" *ngIf="informationsContrat">
                        <div class="scrollbar mb-1" *ngIf="informationsContrat.contrat.id">
                            <shared-information-bank [customStyle]="'true'" [typeEntity]="'affaire'"
                                [allowed_to_update_affaire]="allowed_to_update_affaire"
                                [bankInformation]="informationsContrat.info_bancaire"
                                (onChangesdetect)=" changedetectInfo($event)"
                                (onChangeBankInformation)="getBankInformation($event)"
                                [idAffaire]="affaire_id"></shared-information-bank>
                        </div>
                    </div>
                </div>

                <div class="p-2  ml-4" id=echeancier *ngIf="lecture_transaction_financiere_client && informationsContrat.contrat.id ">
                    <app-echeancier [transaction_financiere_client]="ecriture_transaction_financiere_client"
                        [allowed_to_update_affaire]="allowed_to_update_affaire"
                        (echeanciersexport)="getlistecheancier($event)" (refreshContrat)="reloadContrat($event)" [balance]="informationsContrat?.solde?.montant"></app-echeancier>
                </div>
                <div class="p-2  ml-4" id=paimentfrais>
                    <app-paiment-frais [allowed_to_update_affaire]="allowed_to_update_affaire" *ngIf="informationsContrat.contrat.id"
                        (paimentfraisexport)="getlistpaimentfrais($event)" [idAffaire]="affaire_id" (soldeAffaire)="getInformationsContrat()" ></app-paiment-frais>
                </div>
                <div class="p-2  ml-4" id=transactionFinanciere  *ngIf="lecture_transaction_financiere_client"> 
                    <app-transaction-financiere #transactionFinance [solde]="informationsContrat?.solde?.montant" [allowed_to_update_affaire]="allowed_to_update_affaire" (soldeAffaire)="getInformationsContrat()"
                       ></app-transaction-financiere>
                </div>
                <div *ngIf="affaire_id.trim() != '' && id_opportunite.trim() != '' && prospect_id.trim() != ''"
                    class="p-2 ml-4" id="ListDocuments">
                    <app-list-documants [allowed_to_update_affaire]="allowed_to_update_affaire"
                        (listDocumentsOpporExport)="getListDocOpp($event)" (listdocumentexport)="getListDoc($event)"
                        [affaire_id]="affaire_id" [id_opportunite]="id_opportunite" [prospect_id]="prospect_id"
                        [contrat_id]="contrat_id"></app-list-documants>
                </div>
                <div class="p-2  ml-4" id="LiaisonsContrats" *ngIf="informationsContrat != null ">
                    <app-liaisons-contracts [allowed_to_update_affaire]="allowed_to_update_affaire"
                        [informationsContrat]="informationsContrat"
                        (listContratEnLiasonExport)="getlistContratenliason($event)"></app-liaisons-contracts>
                </div>
                <div *ngIf="affaire_id.trim() != '' && id_opportunite.trim() != ''" class="p-2  ml-4" id="Tickets">
                    <app-tickets [allowed_to_update_affaire]="allowed_to_update_affaire"
                        (listticketsexport)="getlistticket($event)" [affaire_id]="affaire_id"
                        [id_opportunite]="id_opportunite" [prospect_id]="prospect_id">
                    </app-tickets>
                </div>
                <div class="p-2  ml-4" id="tache">
                    <app-tache [allowed_to_update_affaire]="allowed_to_update_affaire"  ></app-tache>
                </div>
                <div class="p-2  ml-4" id="InfAvancee" *ngIf="affaire_id.trim() != '' && id_opportunite.trim() != ''">
                    <app-information-avancees [allowed_to_update_affaire]="allowed_to_update_affaire"
                        (infoComplementaireexport)="getlistComp($event)" (infoSpecifiqueexport)="getlistSpecif($event)"
                        (onUpdateinformationsComp)="submitInfoCompl($event)"
                        (onUpdateinformationsSpecifique)="submitInfoSpecifique($event)" [affaire_id]="affaire_id"
                        [id_opportunite]="id_opportunite">
                    </app-information-avancees>
                </div>
                <div class="p-2 ml-4" id="comment">

                    <app-add-commentaire (commentaireExport)="getlistcommentaireexport($event)"
                        [allowed_to_update]="allowed_to_update_affaire" [fromType]="'A'"></app-add-commentaire>
                </div>
                <div *ngIf="affaire_id.trim() != '' && id_opportunite.trim() != '' " class="p-2  ml-4"
                    id="Communication">

                    <app-add-communication [allowed_to_update_affaire]="allowed_to_update_affaire"
                        [affaire_id]="affaire_id" [id_opportunite]="id_opportunite" [listParent]="listParent"
                        [fromtype]="'A'" [listTypes]="listTypes" [type_envoie]='type_envoie'
                        [statut_envoi]="statut_envoi" [statut]="statut" [prospect]="prospect" [telNumber]="telNumber">
                    </app-add-communication>

                </div>



                <div class="p-2  ml-4" id="Historique" *ngIf=" histAccess">
                    <app-historique [allowed_to_update_affaire]="allowed_to_update_affaire"></app-historique>
                </div>
                <div class="p-2  ml-4" id="HistoriqueCommunication" *ngIf=" histCommAccess">
                    <app-historiques-communication 
                        [allowed_to_update_affaire]="allowed_to_update_affaire"></app-historiques-communication>
                </div>

                <div class="p-2 mb-4 ml-4" id="qualite"  *ngIf="access_qualite">
                    <app-bloc-qualite [affaire_id]="affaire_id"
                     (dataformQuality)="getQualityData($event)" 
                     (detectchangeQualite)="detectChangeQuality($event)"
                     [allowed_to_update_affaire]="allowed_to_update_affaire"
                       ></app-bloc-qualite>
                </div>
            </div>
        </div>
    </div>

</div>




<div *ngIf="appearModel">
    <div class="modal fade" id="Actions" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog  actions-dialog" role="document">
            <div class="modal-content modal-first w-100">
                <div class="modal-header text-center">
                    <div class="row w-100">
                        <div class="col-3">

                        </div>
                        <div class="col-6">
                            <p class="text-center justify-content-center m-0 align-items-center title">
                                {{'languages.affaire.updateAffaire' | translate}}
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                            (click)="resetStatus()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
                <div class="modal-body ">
                    <div class="row text-center justify-content-center" *ngIf="appear">
                        <div class="row">
                            <p class="custemPara">
                                {{'languages.affaire.infirmSave' | translate}} </p>
                        </div>
                        <div class="row d-flex justify-content-center mt-2 mb-3 ">
                            <div class="col-6">
                                <button type="button" class="btn-dt-save-popup sizeC mr-3"
                                    [allowed_to_update]="allowed_to_update_affaire" (click)="updateAffaire()"
                                    data-dismiss="modal" aria-label="Close">
<i class="fa-solid fa-circle-check mr-2 fa-lg fa-icon-style"></i>&nbsp;
                                    {{'languages.affaire.saveQuit' | translate}}
                                </button>
                            </div>
                            <div class="col-6">
                                <button type="button" class="changeStatus " (click)="statutappear()">
                                    <span class="mb-1">{{'languages.affaire.changeStatut' | translate}}</span>
                                    <i class="fa-solid fa-arrow-right fa-icon-style   ml-3 fa-lg"></i>
                                </button>
                            </div>
                         


                        </div>
                    </div>
                    <div class="row text-center justify-content-center paddingBlock" *ngIf="!appear && !step">
                        <ng-container *ngIf="show_loading_status">
                            <div class="row">
                                <div class="col-12 text-center">
                                    <div
                                        style="width: min-content; margin: auto; margin-bottom: 50px; margin-top: 50px">
                                        <mat-spinner [diameter]="30"></mat-spinner>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <div class="row text-center justify-content-center w-100" *ngIf="!show_loading_status">
                            <ng-container *ngFor="let item of status_autorise.listCategory">
                                <div class="col w-100 paddingBlock scrollAp customHeight">
                                    <div class="row w-100">
                                        <div class="col-12 style-div title text-center">
                                            {{'languages.listing.Service' | translate}} : <b class="title-custem">{{item.label}}</b>
                                        </div>
                                        <div class="col-12 w-100">
                                            <div class="row w-100">
                                                <ng-container *ngFor="let status of item.listactions">
                                                    <div class="col-4 text-center style-div">
                                                        <button
                                                            [disabled]="(status.dependance!==status_id && status.dependance!==null)|| status.access_sup == false "
                                                            [ngStyle]="{'opacity':(status.dependance!==status_id && status.dependance!==null)|| status.access_sup == false ? 0.4 : none}"
                                                            (click)="updateSubActionsList(status?.id); appearS()"
                                                            class="btn-affect border-0"
                                                            [style]="{'background-color': status?.color, 'color': status?.couleur_police}">

                                                            <p>{{status?.etat}}  <span
                                                                    *ngIf="status.etat == prospect.etat"
                                                                    style="color: darkred">*</span>
                                                            </p>
                                                            
                                                        </button>
                                                    </div>
                                                </ng-container>

                                            </div>
                                            <div class="row w-100 mt-3 justify-content-center" *ngIf="!appear">
                                                <button type="reset" class="btn-dt-cancel-popup" data-dismiss="modal"
                                                    aria-label="Close">
<i class="fa-solid fa-circle-xmark fa-icon-style fa-lg mr-1"></i>
                                                        {{'languages.buttons.annuler' | translate}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div *ngIf="step||!appear">
                        <div class="   justify-content-center align-items-center">
                            <ng-container *ngIf="show_loading">
                                <div class="row mb-3 mt-3">
                                    <div class="text-center m-auto ">
                                        <mat-spinner [diameter]="50"></mat-spinner>

                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!show_loading">
                                <div class="row scrollAp" *ngIf="subStatusList.length>0 && step">
                                    <div class=" col-4 text-center style-div" *ngFor="let status of subStatusList">
                                        <button class="btn-affect border-0 w-100"
                                        [disabled]="(status.dependance!==status_id && status.dependance!==null)|| status.access_sup == false "
                                        [ngStyle]="{'opacity':(status.dependance!==status_id && status.dependance!==null)|| status.access_sup== false ? 0.4 : none}"
                                        (click)="updateSubActionsList(status?.id)" class="btn-affect"
                                            [style]="{'background-color': status.color, 'color': status.couleur_police}">

                                            <p>{{status?.etat}}  <span *ngIf="status.etat == prospect.etat"
                                                    style="color: darkred">*</span></p>
                                        </button>
                                    </div>
                                    <div class="col-12 mt-4 d-flex justify-content-center">
                                        <button type="reset" class="btn-dt-cancel-popup" data-dismiss="modal"
                                            aria-label="Close" (click)="resetStatus()">
<i class="fa-solid fa-circle-xmark fa-icon-style fa-lg mr-1"></i>
                                            {{'languages.buttons.annuler' | translate}}
                                        </button>
                                    </div>
                                </div>
                                <div class="row scrollAp customHeight" *ngIf="liste_motif.length >0 && !show_massage">
                                    <div class="col-12">
                                        <h2 class="text-center m-auto custemParaa">
                                             {{'languages.affaire.changeMotif' | translate}}
                                        </h2>
                                    </div>
                                    <div class=" col-4 text-center style-div" *ngFor="let motif of liste_motif">
                                        <button class="btn-affect border-0 w-100" (click)="getMotif(motif?.id)"
                                            class="btn-affect"
                                            [disabled]="!motif.active"
                                            [class.disabled]="!motif.active"
                                            [style]="{'background-color': motif.background, 'color': motif.color}">
                                            <p>{{motif?.libelle}} </p>
                                        </button>
                                    </div>
                                    <div class="col-12 mt-4 d-flex justify-content-center">
                                        <button type="reset" class="btn-dt-cancel-popup" data-dismiss="modal"
                                            aria-label="Close" (click)="resetStatus()">
<i class="fa-solid fa-circle-xmark fa-icon-style fa-lg mr-1"></i>
                                            {{'languages.buttons.annuler' | translate}}  
                                        </button>
                                    </div>
                                </div>
                                <div class="row mt-4 " *ngIf="subStatusList.length == 0 && step && show_massage ">
                                    <div class="col-12 text-center">
                                        <h2 class="text-center m-auto custemPara">
                                            {{'languages.affaire.confirmUpdateStatut' | translate}}
                                        </h2>
                                    </div>
                                    <div class="col-12 w-100 justify-content-center d-flex">
                                        <div class="row mt-2  justify-content-center d-flex">
                                            <div class="col-6 col-6 d-flex justify-content-end">
                                                <button (click)="toggleupdate()" class="btn-dt-save-popup mr-3">
                                                    <i class="fa-solid fa-circle-check mr-1 fa-lg"></i>
                                                    {{'languages.affaire.Oui' | translate}}
                                                </button>
                                            </div>
                                            <div class="col-6 d-flex justify-content-start">
                                                <button type="reset" class="btn-dt-cancel-popup " data-dismiss="modal"
                                                    (click)="resetStatus()">
<i class="fa-solid fa-circle-xmark fa-icon-style fa-lg mr-1"></i>
                                                        {{'languages.affaire.Non' | translate}}
                                                </button>
                                            </div>



                                        </div>
                                    </div>
                                </div>




                            </ng-container>

                        </div>


                        <!--   <div class="row mt-3" *ngIf="subStatusList.length>0  && !show_massage">
                            <div class="col-12">
                                <button type="reset" class="btn-dt-cancel-popup" data-dismiss="modal" aria-label="Close"
                                    (click)="resetStatus()">
                                    <fa-icon class="fa-icon-style" [icon]="fa['faTimesCircle']"></fa-icon>&nbsp;
                                    Annuler
                                </button>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>





<div class="modal fade" id="subActionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
    aria-hidden="true">
    <div class="modal-dialog model-lg modal-dialog-centered" role="document">
        <div class="modal-content modal-sec w-100">
            <div class="modal-header text-center">
                <div class="row w-100">
                    <div class="col-3"></div>
                    <div class="col">
                        <h2 class="text-center justify-content-center w-100" id="exampleModalLongTitle">
                            {{'languages.affaire.updateAffaire' | translate}}  
                        </h2>
                    </div>
                </div>
                <div class="row w-100">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
            <div class="modal-bodyy paddingBlock ">
                <ng-container *ngIf="show_loading">
                    <div class="row mb-3 mt-3">
                        <div class="text-center m-auto ">
                            <mat-spinner [diameter]="50"></mat-spinner>

                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!show_loading" class="">
                    <div class="row " *ngIf="subStatusList.length>0">
                        <ng-container *ngFor="let status of subStatusList">
                            <div class="col-6 text-center style-div ">
                                <button class="btn-affect border-0 "
                                    [ngStyle]="{'opacity':(status.dependance!==status_id && status.dependance!==null) || status.access_sup==false ? 0.4 : none}"
                                    [disabled]="status.etat == prospect.etat || (status.dependance!==status_id && status.dependance!==null)|| status.access_sup==false"
                                    (click)="updateSubActionsList(status?.id)" class="btn-affect"
                                    [style]="{'background-color': status.color, 'color': status.couleur_police}">

                                    <p>{{status?.etat}} <span *ngIf="status.etat == prospect.etat"
                                            style="color: darkred">*</span></p>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                    <div class="row" *ngIf="subStatusList.length==0 && liste_motif.length == 0 ">
                        <h2 class="text-center m-auto custemPara">
                              {{'languages.affaire.confirmUpdateStatut' | translate}}
                        </h2>
                    </div>
                    <div *ngIf="subStatusList.length == 0 && liste_motif.length == 0"
                        class="d-flex justify-content-center text-center">
                        <button (click)="changeAction()" class="btn-dt-save-popup " data-dismiss="modal"
                            aria-label="Close">
<i class="fa-solid fa-circle-check mr-1 fa-lg "></i>
                            {{'languages.affaire.Oui' | translate}}
                        </button>
                        <button type="reset" class="btn-dt-cancel-popup " data-dismiss="modal">
                            <i class="fa-solid fa-circle-xmark mr-1 fa-lg fa-icon-style"></i>
                            {{'languages.affaire.Non' | translate}}
                        </button>
                    </div>
                    <div class="row" *ngIf="liste_motif.length > 0 && subStatusList.length==0">
                        <div class="col-12">
                            <h2 class="text-center m-auto custemParaa">
                                {{'languages.affaire.changeMotif' | translate}}
                            </h2>
                        </div>
                        <div class=" col-4 text-center style-div" *ngFor="let motif of liste_motif">
                            <button class="btn-affect border-0 w-100" 
                            (click)="getMotif(motif?.id)" class="btn-affect"
                            [disabled]="!motif.active"
                              [class.disabled]="!motif.active"
                                [style]="{'background-color': motif.background, 'color': motif.color}">
                                <p>{{motif?.libelle}} </p>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>

        </div>

    </div>
</div>







<div *ngIf="showModal">
    <div id="myModal" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog model-lg modal-dialog-centered" role="document">
            <div class="modal-content modal-avenant">
                <div class="modal-header d-flex justify-content-center align-items-center">
                    <h2 class="text-center justify-content-center title m-0 w-100" id="exampleModalLabel">{{'languages.affaire.createAvenant' | translate}} </h2>
                    <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="modal-body">
                    <!-- <div class="row">
                        <div class="col">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <h3 class="title-avenant">Créer un avenant
                            </h3>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-12 w-100">
                            <mat-form-field class="example-full-width w-100">
                                <mat-label>{{'languages.affaire.Motif' | translate}}:</mat-label>
                                <mat-select [formControl]="MotifControl" required>
                                    <mat-option *ngFor="let motif of listMotif" [value]="motif.id">
                                        {{motif.libelle}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="MotifControl.hasError('required')">{{'languages.alerts.motifOblig' | translate}}</mat-error>
                                <mat-hint>{{'languages.alerts.motifOblig' | translate}} </mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-12 w-100 mt-3">
                            <div class="card-commentaire p-2">
                                <mat-form-field class="w-100">
                                    <textarea [(ngModel)]="commentaire" name="description" class="textarea-style"
                                        matInput rows="8" placeholder="{{'languages.opportunite.details.commentaire' | translate}}">
                                    </textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="addAvenantLoader" >
                      
                        <div class="row d-flex mt-2 justify-content-center">
                            <div class="text-center m-auto ">
                                <mat-spinner [diameter]="25"></mat-spinner>
            
                            </div>
                        </div>
                    </ng-container>
                    <div class="row d-flex justify-content-center mt-2">
                      
                            <button type="button" class="btn-dt-save-popup custemSize mr-2" (click)="creerAvenant()"
                                >
<i class="fa-solid fa-circle-check mr-1 fa-icon-style"></i>
                                {{'languages.buttons.ajouter' | translate}}
                            </button>

                            <button type="button" class="btn-dt-cancel-popup ml-2 custemSize" data-dismiss="modal"
                                aria-label="Close">
<i class="fa-solid fa-circle-xmark mr-1 fa-icon-style"></i>
                                {{'languages.buttons.annuler' | translate}}  
                            </button>
                       
                           
                        
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>











<div *ngIf="showModalMotif">
    <div class="modal fade" id="MotifChange" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
        aria-hidden="true">
        <div class="modal-dialog  actions-dialog" role="document">
            <div class="modal-content modal-sec w-100">
                <div class="modal-header text-center">
                    <div class="row w-100">
                        <div class="col-10"></div>
                        <div class="col-2">
                            <h2 class=" ml-3 text-center text-nowrap justify-content-center w-100 d-flex"
                                id="exampleModalLongTitle">
                                {{'languages.affaire.ModifierMotif' | translate}} 
                            </h2>
                        </div>

                    </div>
                    <div class="row w-100">
                        <button (click)="resetMotif()" type="button" class="close" data-dismiss="modal"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
                <div class="modal-bodyy paddingBlockkk scrollAp ">
                    <ng-container *ngIf="loadermotifActuel">
                        <div class="row mb-3 mt-3">
                            <div class="text-center m-auto ">
                                <mat-spinner [diameter]="50"></mat-spinner>

                            </div>
                        </div>
                    </ng-container>
                    <ng-container>
                        <div class="row mt-3" *ngIf="list_motif_statut_actuel.length > 0">
                            <div class=" col-3 text-center style-div" *ngFor="let motif of list_motif_statut_actuel">
                                <button class="btn-affect border-2 w-100" 
                                (click)="updateMotif(motif?.id)"
                                [disabled]="!motif.active"
                                            [class.disabled]="!motif.active"
                                    [style]="{'background-color': motif.background, 'color': motif.color}">
                                    <p>{{motif?.libelle}} </p>
                                </button>
                            </div>
                            <div class="col-12 mt-3 mb-4 justify-content-center d-flex">
                                <button type="reset" class="btn-dt-cancel-popup" data-dismiss="modal" aria-label="Close"
                                    (click)="resetMotif()">
<i class="fa-solid fa-circle-xmark mr-1 fa-icon-style"></i>
                                    {{'languages.buttons.annuler' | translate}}  
                                </button>
                            </div>
                        </div>
                        <div class="row justify-content-center text-center"
                            *ngIf="list_motif_statut_actuel.length == 0 && !loadermotifActuel ">
                            <label class="text-center justify-content-center mt-5 text-wrn"> {{'languages.affaire.noMotif' | translate}}  </label>
                        </div>
                    </ng-container>
                </div>

            </div>
        </div>
    </div>
</div>
